<template>
  <BaseModal :open="open" maxWidth="420px" :position="['top', 'center']" :modalStyle="['margin-top:8%']"
             @close="$emit('close')">
    <div class="v2026-ro">
      <div class="v2026-ro__head">
        <span class="v2026-ro__title">จัดลำดับเมนู</span>
        <button type="button" class="v2026-ro__close" aria-label="ปิด" @click="$emit('close')">×</button>
      </div>
      <div class="v2026-ro__body">
        <p class="v2026-ro__hint">ลากเพื่อสลับลำดับ · บันทึกไว้ในเบราว์เซอร์นี้เท่านั้น</p>
        <!-- แก้บนสำเนา: ยกเลิก/ปิดแล้วแถบจริงต้องไม่ขยับ -->
        <draggable v-model="draft"
                   handle=".v2026-ro__row"
                   ghostClass="v2026-ro__row--ghost"
                   chosenClass="v2026-ro__row--chosen"
                   dragClass="v2026-ro__row--drag"
                   :animation="150">
          <div v-for="item in draft" :key="item.type" class="v2026-ro__row">
            <span class="v2026-ro__grip" aria-hidden="true"></span>
            <span v-if="item.svg" class="v2026-ro__icon" aria-hidden="true"
                  :style="{ '-webkit-mask-image': 'url(' + item.svg + ')', 'mask-image': 'url(' + item.svg + ')' }"></span>
            <i v-else :class="item.icon" aria-hidden="true"></i>
            <span class="v2026-ro__label">{{ item.label }}</span>
          </div>
        </draggable>
      </div>
      <div class="v2026-ro__foot">
        <button type="button" class="v2026-ro__btn v2026-ro__btn--link" @click="$emit('reset')">คืนค่าเริ่มต้น</button>
        <span class="v2026-ro__foot-gap"></span>
        <button type="button" class="v2026-ro__btn" @click="$emit('close')">ยกเลิก</button>
        <button type="button" class="v2026-ro__btn v2026-ro__btn--primary" @click="$emit('save', draft.map(item => item.type))">บันทึก</button>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import draggable from 'vuedraggable'
import BaseModal from '@/components/coversation/BaseModal.vue'

export default {
  name: 'RailOrderModalV2026',
  components: { draggable, BaseModal },
  props: {
    open: { type: Boolean, default: false },
    // รายการตามลำดับที่แถบแสดงอยู่ตอนนี้ ({ type, label, svg, icon })
    items: { type: Array, default: () => [] }
  },
  data () {
    return {
      draft: []
    }
  },
  watch: {
    open: {
      immediate: true,
      handler (isOpen) {
        if (isOpen) this.draft = this.items.slice()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v2026-ro__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #FFFFFF;
  border-bottom: 1px solid #EBEDF0;
  padding: 16px 24px;
}
.v2026-ro__title {
  font-size: 16px;
  font-weight: 600;
  color: #1F2937;
}
.v2026-ro__close {
  border: none;
  background: none;
  padding: 0;
  font-size: 20px;
  line-height: 1;
  color: #66696C;
  cursor: pointer;
}
.v2026-ro__body {
  padding: 16px 24px 8px;
  max-height: 60vh;
  overflow-y: auto;
}
.v2026-ro__hint {
  margin: 0 0 12px;
  font-size: 13px;
  color: #66696C;
}
.v2026-ro__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 6px;
  background: #FFFFFF;
  border: 1px solid #EBEDF0;
  border-radius: 10px;
  cursor: grab;
  user-select: none;
  touch-action: none;

  &:hover { border-color: #D0D5DD; }
  &--chosen { background: #f5f5f5; }
  &--drag {
    background: #FFFFFF;
    box-shadow: 0 8px 20px rgba(0, 0, 0, .16);
    opacity: 1;
  }
  &--ghost {
    background: #31C1D714;
    border-style: dashed;
    border-color: #31C1D7;

    > * { visibility: hidden; }
  }
}
.v2026-ro__grip {
  flex: 0 0 auto;
  width: 10px;
  height: 16px;
  color: #98A2B3;
  background-image: radial-gradient(currentColor 1px, transparent 1.2px);
  background-size: 5px 5px;
  background-position: 0 2px;
  background-repeat: repeat;
}
.v2026-ro__icon {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: #66696C;
}
.v2026-ro__label {
  font-size: 14px;
  color: #1F2937;
}
.v2026-ro__foot {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px 20px;
}
.v2026-ro__foot-gap {
  flex: 1 1 auto;
}
.v2026-ro__btn {
  border: 1px solid #D0D5DD;
  background: #FFFFFF;
  color: #1F2937;
  border-radius: 10px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;

  &--primary {
    background: #31C1D7;
    border-color: #31C1D7;
    color: #FFFFFF;
  }
  &--link {
    border: none;
    background: none;
    padding: 8px 0;
    color: #66696C;
    text-decoration: underline;
  }
}
</style>
